<template>
   <form class="container ">
        <div class="form-group">
            <label>Full name</label>
            <input type="text" class="form-control" v-model="fullName">
        </div>
        <div class="form-group">
            <label>Email</label>
            <input type="text" class="form-control" v-model="email">
        </div>

        <button type="submit" class="btn btn-light me-2" @click.prevent="updateAdmin">Update</button>
        <button type="button" class="btn btn-light" v-on:click="$emit('toggle')">Cancel</button>

        <div class="form-group">
            <label>Password</label>
            <div class="passowrdInput">
                <input :type="showPass ? 'text' : 'password'" class="form-control" v-model="password">
                <i class="fa-solid fa-eye" @click="showPass = false" v-if="showPass"></i>
                <i class="fa-solid fa-eye-slash" @click="showPass = true" v-if="!showPass"></i>
                <button class="btn btn-light me-2" @click.prevent="generatePassword">Generate password</button>
            </div>
        </div>
        <button type="submit" class="btn btn-light me-2" @click.prevent="updatePassword">Update password</button>
    </form>
</template>
<script>
import axios from 'axios'
import APIs from './../../../../config'
export default {
    name: "AddBlog" ,
    data(){
        return {
            fullName: this.blog.fullName,
            email: this.blog.email,
            password: "",

            showPass: false,
            showConfirmPass: false,

            get_token: localStorage.getItem('admin_token'),
            user_id: localStorage.getItem('admin_id'),

            isActive: this.blog.isActive
        }
    },
    props : {
        blog : Object
    },
    created() {
        console.log(this.blog)
    },
    methods : {
        updatePassword() {
            let formData = {
                password: this.password
            }

            axios.put(`${APIs.API_URL}/admin/editeOneAdmin/${this.user_id}/${this.blog._id}`, formData,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.get_token}`
                }
            })
            .then(() => {
                   this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "password updated",
                    showConfirmButton: false,
                    timer: 1500
                });
            })
            .catch( (error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            });
        },
        updateAdmin() {
            let formData = {
                fullName: this.fullName,
                email: this.email
            }

            axios.put(`${APIs.API_URL}/admin/editeOneAdmin/${this.user_id}/${this.blog._id}`, formData,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.get_token}`
                }
            })
            .then(() => {
                   this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Updated",
                    showConfirmButton: false,
                    timer: 1500
                });
            })
            .catch( (error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            });
        },
        setImage(event){
            this.image = event.target.files[0]
        },
        generatePassword() {
            var chars = "0123456789~!@#$%^&*()_+}{[]|abcdefghikjlmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
            var pass = "";
            var passLength = 16;
            for (var i = 0; i < passLength; i++) {
                var randPass = Math.floor(Math.random() * chars.length);
                pass += chars.substring(randPass, randPass+1);
            }
            this.password = pass
            this.confirmPass = pass
        },
        addBlog(){
            let formData = {
                fullName: this.fullName,
                email: this.email,
                password: this.password,
                confirmPass: this.confirmPass
            }
            var get_token = localStorage.getItem('admin_token')
            var user_id = localStorage.getItem('admin_id')
            axios.post(`${APIs.API_URL}/admin/signUp/${user_id}`, formData,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${get_token}`
                }
            })
            .then(() => {
                   this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Added",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$emit("refresh")
            })
            .catch( (error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            });
        }
    }
}
</script>

<style scoped lang="scss">
    input {
        width: 80%;
    }
    .passowrdInput {
        display: flex;
        align-items: baseline;
        width: 100%;
        input {
            width: 70%;
            margin-right: 2%;
        }
        i {
            width: 5%;
            font-size: 20px;
            cursor: pointer;
        }
    }
</style>
